import React from 'react';
import { Link } from 'react-router-dom';
import { branding } from '../constants/branding';

const Footer: React.FC = () => {
  const { footer } = branding;

  return (
    <footer style={{
      background: footer.background,
      height: footer.height,
      borderTop: `1px solid ${branding.borderColor}`,
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '0 24px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '1200px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        color: footer.textColor,
        fontSize: '14px'
      }}>
        <div>
          © {new Date().getFullYear()} {branding.sidebar.logoText}. All rights reserved.
        </div>
        <div style={{ display: 'flex', gap: '24px' }}>
          <Link to="/terms" style={{ color: footer.linkColor, textDecoration: 'none' }}>
            Terms & Conditions
          </Link>
          <Link to="/privacy" style={{ color: footer.linkColor, textDecoration: 'none' }}>
            Privacy Policy
          </Link>
          <Link to="/contact" style={{ color: footer.linkColor, textDecoration: 'none' }}>
            Contact Us
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 